import ListItem from 'components/atoms/ListItem';
import BaseModal from 'components/molecules/BaseModal';
import SearchBar from 'components/molecules/SearchBar';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import RelatedDocumentsList from './RelatedDocumentsList';
import RelatedDocumentsSelected from './RelatedDocumentsSelected';
import api from 'services/api';
import './styles.scss';
import Dropzone from '../Dropzone';
import Button from 'components/atoms/Button';

const RelatedDocumentsModal = ({ setRelatedData, document, selectedLinks, setSelectedLinks }) => {
    const { setDocumentsAll, user, filter, relatedDocumentsModal, setRelatedDocumentsModal, setResponseMsg, setLoading, searchTerm } = useContext(GlobalContext);
  const [documentsModal, setDocumentsModal] = useState([]);
  const [existingLinks, setExistingLinks] = useState(document?.Links || []);
  const [selectedDocuments, setSelectedDocuments] = useState(document?.Documentos || []);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const paginationMax = 10;
  const paginationMin = 1;

  const isSelected = useCallback(
    (id, tipoDoc) => {
      return !!selectedDocuments?.find((doc) => doc.IDDoc === id && doc.TipoDoc === parseInt(tipoDoc));
    },
    [selectedDocuments],
  );

  function filteredDocuments(documents, filtered) {
    const id = filtered.IDDoc || filtered.ID;
    return documents?.filter((selected) => !(selected.IDDoc === id && selected.TipoDoc === parseInt(filtered.TipoDoc)));
  }

  const handleSelectedDocuments = useCallback(
    (doc) => {
      if (isSelected(doc.ID, doc.TipoDoc)) {
        setSelectedDocuments((prevState) => filteredDocuments(prevState, doc));
      } else {
        setSelectedDocuments((prevState) => [
          ...prevState,
          { ID: 0, IDDoc: doc.ID, TipoDoc: doc.TipoDoc, NDocumento: doc.NRDocumento, Nome: doc.Titulo },
        ]);
      }
    },
    [isSelected],
  );

  useEffect(() => {
    setLoading(true);
    api
      .getDocumentsPaginated(null, paginationMin, paginationMax, searchTerm)
      .then(({ Item }) => {
          setDocumentsModal(Item);
          return api.getDocumentsAll(user, searchTerm, filter)
      })
        .then((data) => {
            return setDocumentsAll(data.Item)

        })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      })
      .finally(() => setLoading(false));
  }, [searchTerm, setDocumentsModal, setLoading, setResponseMsg]);

  function handleClick() {
    setRelatedData({ links: [...existingLinks, ...selectedLinks], files: selectedFiles, documents: selectedDocuments });
    setRelatedDocumentsModal({ isVisible: false });
  }

  return (
    <BaseModal isVisible={relatedDocumentsModal.isVisible} handleClose={() => setRelatedDocumentsModal({ isVisible: false })}>
      <div className="relatedDocumentsModal">
        <RelatedDocumentsList>
          <SearchBar />
          <ul className="list__items">
            {documentsModal &&
              documentsModal.map((doc) => (
                <ListItem
                  key={doc.ID}
                  id={doc.ID}
                  title={`${doc.NRDocumento} - ${doc.Titulo}`}
                  check
                  selected={isSelected(doc.ID, doc.TipoDoc)}
                  handleSelected={() => handleSelectedDocuments(doc)}
                />
              ))}
          </ul>
        </RelatedDocumentsList>
        <RelatedDocumentsSelected>
          {selectedDocuments &&
            selectedDocuments.map((doc, index) => (
              <ListItem
                key={`${doc.IDDoc}-${index}`}
                id={`${doc.IDDoc}-selected`}
                title={`${doc.NDocumento} - ${doc.Nome}`}
                removable
                onRemove={() => setSelectedDocuments((prevState) => filteredDocuments(prevState, doc))}
              />
            ))}
        </RelatedDocumentsSelected>
        <Dropzone
          selectedFiles={selectedFiles}
          selectedLinks={selectedLinks}
          setSelectedFiles={setSelectedFiles}
          setSelectedLinks={setSelectedLinks}
          existingLinks={existingLinks}
          setExistingLinks={setExistingLinks}
        />
        <Button type="button" visual="btnOk" onClick={handleClick}>
          OK
        </Button>
      </div>
    </BaseModal>
  );
};

export default RelatedDocumentsModal;
